import { shallowEqual, MapDispatchToProps } from 'react-redux';
import { connectMediaStore, useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource, getTopLevelGallections } from '../selectors';
import { fetchMoreGallections } from '../actions';
import { PapiGallection } from '@wix/da-papi-types';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';

export type WithGallectionsProps = {
  gallections: PapiGallection[];
  hasMoreGallections: boolean;
  isFetchingGallections: boolean;
  isGallectionStreamInitialized: boolean;
  fetchMoreGallections: () => any;
};

type StateProps = Pick<
  WithGallectionsProps,
  'gallections' | 'hasMoreGallections' | 'isFetchingGallections' | 'isGallectionStreamInitialized'
>;
type DispatchProps = Pick<WithGallectionsProps, 'fetchMoreGallections'>;
type OwnProps = Omit<WithGallectionsProps, keyof (StateProps & DispatchProps)>;

const mapStateToProps = state => {
  const mediaSource = getCurrentMediaSource(state);
  const streamId = getGallectionStreamId(mediaSource);
  const putScrapsFolderLast = (a, b) => (b.folderId === SCRAPS_FOLDER_ID ? -1 : 0);
  const gallections = getTopLevelGallections(state).sort(putScrapsFolderLast);
  return {
    gallections,
    hasMoreGallections: selectors.hasMore(state, streamId),
    isFetchingGallections: selectors.isFetching(state, streamId),
    isGallectionStreamInitialized: selectors.isInitialized(state, streamId),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  fetchMoreGallections,
};

export const useGallections = (): WithGallectionsProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({ fetchMoreGallections }),
});

export default connectMediaStore(mapStateToProps, mapDispatchToProps);
